import store from '@/store'

export default [
  {
    path: '/grading-definitions',
    name: 'grading-definition',
    meta: { requiresAuth: true },
    component: () => import('@/pages/grading-definition/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('gradingDefinition/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/grading-definitions/:id',
    name: 'grading-definition-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/grading-definition/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('gradingDefinition/find', to.params.id)
      await store.dispatch('gradingDefinition/dataBeforeCreate')
      next()
    }
  }
]
